import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/heroimg.png'
import _imports_1 from '@/assets/preload.gif'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<section class=\"bg-white dark:bg-gray-900\"><div class=\"mx-auto grid max-w-screen-xl px-4 py-8 lg:grid-cols-12 lg:gap-8 lg:py-16 xl:gap-0\"><div class=\"mr-auto place-self-center lg:col-span-7\"><h1 class=\"mb-4 max-w-2xl text-4xl font-extrabold leading-none tracking-tight dark:text-white md:text-5xl xl:text-6xl\"> Convert SVG with simple structure to full on-chain NFT </h1><p class=\"mb-6 max-w-2xl font-light text-gray-500 dark:text-gray-400 md:text-lg lg:mb-8 lg:text-xl\"> All data is converted to the d attribute of the path element. <br> Only circle, ellipses, line, rect, polygon, polyline element are converted to the d attribute of the path element. All other elements are ignored. </p></div><div class=\"hidden lg:col-span-5 lg:mt-0 lg:flex\"><img class=\"rounded-2xl\" src=\"" + _imports_0 + "\" alt=\"mockup\"></div></div></section>", 1)
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = { class: "flex h-32 w-full cursor-pointer appearance-none justify-center rounded-md border-2 border-dashed border-gray-300 bg-white px-4 transition hover:border-gray-400 focus:outline-none" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "flex items-center space-x-2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-6 w-6 text-gray-600",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "stroke-width": "2"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "font-medium text-gray-600" }, [
    /*#__PURE__*/_createTextVNode(" Drop your SVG file, or "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-blue-600 underline" }, "browse")
  ])
], -1)
const _hoisted_6 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", null, "Original SVG", -1)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h2", null, "NFT Image", -1)
const _hoisted_13 = { class: "mx-auto mb-6 w-64" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "price",
  class: "mb-2 block text-sm font-medium text-gray-900 dark:text-white"
}, "Price", -1)
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "flex justify-center" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-20 w-20",
  src: _imports_1
}, null, -1)
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NetworkGate = _resolveComponent("NetworkGate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_NetworkGate, { expectedNetwork: _ctx.chainId }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            onDragover: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
            onDrop: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
            class: "flex justify-center"
          }, [
            _createElementVNode("div", {
              onDrop: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dragFile && _ctx.dragFile(...args))),
              class: "m-4 w-full"
            }, [
              _createElementVNode("label", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("input", {
                  type: "file",
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args))),
                  class: "hidden"
                }, null, 32)
              ])
            ], 32)
          ], 32),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.svgData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("img", {
                    src: _ctx.svgData,
                    class: "mx-auto my-auto h-48 w-48"
                  }, null, 8, _hoisted_8),
                  _hoisted_9
                ]))
              : _createCommentVNode("", true),
            (_ctx.convedSVGData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("img", {
                    src: _ctx.convedSVGData,
                    class: "mx-auto my-auto h-48 w-48"
                  }, null, 8, _hoisted_11),
                  _hoisted_12
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.set_price) = $event)),
              type: "text",
              id: "price",
              class: _normalizeClass(["block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500", _ctx.isExecuting == 1 ? 'bg-gray-500 bg-opacity-80' : 'bg-gray-100']),
              placeholder: "Input Price (ETH)",
              disabled: _ctx.isExecuting == 1,
              required: ""
            }, null, 10, _hoisted_15), [
              [_vModelText, _ctx.set_price]
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            (_ctx.isExecuting == 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.mint && _ctx.mint(...args))),
                  disabled: !_ctx.existData,
                  class: _normalizeClass(["mr-2 mb-2 rounded-lg bg-gradient-to-br from-purple-600 to-blue-500 px-20 py-5 text-center text-sm font-medium text-white hover:bg-gradient-to-bl focus:outline-none focus:ring-4 focus:ring-blue-300 dark:focus:ring-blue-800", 
              _ctx.existData
                ? 'bg-green-600 focus:bg-green-700'
                : 'bg-green-600 bg-opacity-20 focus:bg-green-700'
            ])
                }, " MINT! ", 10, _hoisted_17))
              : _createCommentVNode("", true),
            (_ctx.isExecuting == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["expectedNetwork"])
    ])
  ]))
}